import img8 from './Diagnostico/img8.jpg'
import img9 from './Diagnostico/img9.jpg'
import img10 from './Diagnostico/img10.jpg'
import img11 from './Diagnostico/img11.jpg'
import img12 from './Diagnostico/img12.jpg'
import img13 from './Diagnostico/img13.jpg'
import img14 from './Diagnostico/img14.jpg'
import img15 from './Diagnostico/img15.jpg'
import img16 from './Diagnostico/img16.jpg'
import img17 from './Diagnostico/img17.jpg'
import img18 from './Diagnostico/img18.jpg'
import img24 from './Diagnostico/img24.jpg'
import React, { Component } from 'react'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'
import { Footer } from './Footer'
import { Navigation } from './Navigation'

export class Diagnostico extends Component {
    render() {
        return (
            <div>
                <Navigation />
                {/* Usamos fluid para que el contenedor use casi todo el ancho de la pantalla */}
                <Container fluid className="px-5"> 
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>Diagnóstico</h1>
                        </Col>
                    </Row>
                    <br />
                    
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/diagnostico2">{2}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* xs={1}: 1 card en celulares
                      md={2}: 2 cards en tablets
                      lg={3}: 3 cards en monitores (aquí se verán grandes)
                      className="g-5": Aumentamos el espacio entre ellas para que respiren
                    */}
                    <Row xs={1} md={2} lg={3} className="g-5 text-center">
                        {[
                            { img: img24, title: "Complementos para estetoscopios" },
                            { img: img10, title: "Esfigmomanómetro aneroide" },
                            { img: img11, title: "Esfigmomanómetro aneroide" },
                            { img: img12, title: "Esfigmomanómetro aneroide" },
                            { img: img13, title: "Esfigmomanómetro aneroide" },
                            { img: img14, title: "Esfigmomanómetro aneroide" },
                            { img: img15, title: "Esfigmomanómetro aneroide" },
                            { img: img8, title: "Esfigmomanómetro de mercurio" },
                            { img: img17, title: "Esfigmomanómetro aneroide" },
                            { img: img18, title: "Esfigmomanómetro aneroide" },
                            { img: img16, title: "Esfigmomanómetro aneroide" },
                            { img: img9, title: "Esfigmomanómetro de pedestal" }
                        ].map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow-sm border-0"> 
                                    {/* style={{ objectFit: 'contain' }} asegura que la imagen no se deforme aunque sea grande */}
                                    <Card.Img 
                                        variant="top" 
                                        src={item.img} 
                                        style={{ height: '300px', objectFit: 'contain', padding: '10px' }} 
                                    />
                                    <Card.Body className="d-flex align-items-center justify-content-center">
                                        <Card.Title style={{ fontSize: '1.4rem' }}>{item.title}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center mt-4" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/diagnostico2">{2}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}